module.exports = __webpack_public_path__ + "img/cover-slot-bg.82ca32bc.png";